<div   class="dropdown" [class.show]="dropdownOpen">
    <button [ngClass]="{ 'disabled': isExtraDisabled}" [disabled]="isExtraDisabled"
      class="w-full btn btn-secondary dropdown-toggle p-dropdown .p-dropdown-label p-component p-inputtext p-dropdown-clearable p-inputwrapper-filled"
      type="button"
      (click)="toggleDropdown()"
      [innerHTML]="dropdownLabel"
    >
  
    </button>
    
    <p-card class="dropdown-menu absolute p-0 extra-dropdown" [class.show]="dropdownOpen">
    
      <div *ngFor="let extra of experiencePriceExtras; let i = index" class="mt-3 priceLabelRow">
        <div class="flex justify-content-between align-items-center">
          <div class="details mr-4 text-left">
            {{extra.name}} <span class="text-xs text-gray-500 block">{{formatCurrencyCents(extra.price_cents)}}</span>
          </div>
          <div class="flex justify-content-between align-items-center">
            <p-button class="quantityButton" icon="pi pi-minus" [rounded]="true" [outlined]="true" (click)="decrement(i); $event.stopPropagation()"></p-button>
            <span class="text-center quantityNumber">{{ extraLabelCounts[i] }}</span>
            <p-button class="quantityButton" icon="pi pi-plus" [rounded]="true" [outlined]="true" (click)="increment(i); $event.stopPropagation()"></p-button>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <div class="total-price">
          <strong>Total Extra Price: </strong> {{ formatCurrencyCents(totalPrice) }}
        </div>
      </div>  
    </p-card>
  
  </div>
  